// extracted by mini-css-extract-plugin
export default {"spin":"HLjIHpFvrqCj1NzHcjn3","icon":"fa8GvZAVduDOuMcnNB_D"};